import React from 'react';
import ReactDOM from 'react-dom';
import ChatSection from './feedbackdetail/ChatSection';
import { connect } from 'react-redux';
import Smiley from './Smiley';
import ReviewSection from './feedbackdetail/ReviewSection';
import FeedbackNote from './feedbackdetail/FeedbackNote';
import FeedbackSection from './feedbackdetail/FeedbackSection';
import NoteSection from './feedbackdetail/NoteSection';
import AttachmentSection from './feedbackdetail/AttachmentSection';
import AdminAttachmentSection from './feedbackdetail/AdminAttachmentSection';
import Dropzone from './feedbackdetail/Dropzone';
import StatusSection from './feedbackdetail/StatusSection';
import TagsSection from './feedbackdetail/TagsSection';
import TextMessageForward from './feedbackdetail/TextMessageForward';
import { setSelectedFeedback, ajaxFeedback, ajaxFeedbackFilter, getRequestedVia, getStarsJSX, getChatStatus, reviewLinkSent, getAttachmentsUrls, ajaxUpdateFeedbackStatus, genEmailButton, updateModalContent, findWithAttr, ajaxArchiveFeedback } from './redux/FeedbackRedux';
import Alert from "./Alert";

class FeedbackDetail extends React.Component {
    constructor(props) {
		super(props);
        this.handleForwardClick = this.handleForwardClick.bind(this);
        this.handleEmailClick = this.handleEmailClick.bind(this);
        this.handleHistoryClick = this.handleHistoryClick.bind(this);
        this.handleArchiveClick = this.handleArchiveClick.bind(this);
        this.handleStatusClick = this.handleStatusClick.bind(this);
	}

    handleForwardClick() {
        event.preventDefault();
		var modal_id = "textForwardModal";
        var modal_title = __("Forward Via Text Message");
		var modal_body = "renderTextForward";
		var button_1_class = "outline-secondary";
		var button_1_id = "cancel";
		var button_1_text = __("Cancel");
		var button_2_class = "primary";
		var button_2_id = "send";
		var button_2_text = __("Send Text Message");
		this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
		jQuery('.modal:not(.error)').modal();
    }

    handleArchiveClick(event){
		if(this.props.feedback.is_archived == 1) {
			event.preventDefault();
			this.props.dispatch(ajaxArchiveFeedback(this.props.feedback.feedback_id));
			this.props.dispatch(ajaxFeedbackFilter(this.props.state.timeframe, this.props.state.status, this.props.feedback.feedback_id, this.props.state.businesses??null, this.props.state.current_page, this.props.state.total_pages, this.props.state.query, this.props.state.other_filter, this.props.state.archive, this.props.state.department_ids??null, (this.props.state.region ? this.props.state.region.id : null), this.props.state.region_type??null));
		} else {
			event.preventDefault();
			var modal_id = "archiveModal";
			var modal_title = __("Archive Feedback");
			var modal_body = __('Archiving this Feedback will remove it from Feedback History and place it in "Feedback Archive" where it will be inaccessible to employees without manager privileges, and by default will not show up in reporting (unless specified)');
			var button_1_class = "outline-secondary";
			var button_1_id = "cancel";
			var button_1_text = __("Cancel");
			var button_2_class = "danger";
			var button_2_id = "archive";
			var button_2_text = __("Archive");
			this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
			jQuery('.modal:not(.error)').modal();
		}
    }

    handleEmailClick(event){
        event.preventDefault();
		var modal_id = "emailForwardModal";
        var modal_title = __("Forward Via Email/Text");
		var modal_body = "renderEmailForward";
		var button_1_class = "outline-secondary";
		var button_1_id = "cancel";
		var button_1_text = __("Cancel");
		var button_2_class = "primary";
		var button_2_id = "email";
		var button_2_text = __("Send Forward Via Email");
		this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
		jQuery('.modal:not(.error)').modal();
    }

    handleHistoryClick() {
        event.preventDefault();
		var modal_id = "forwardHistoryModal";
        var modal_title = __("Forward History For This Feedback");
		var modal_body = "renderForwardHistory";
		var button_1_class = "outline-secondary";
		var button_1_id = "cancel";
		var button_1_text = __("Close");
		var button_2_class = "hide";
		var button_2_id = "none";
		var button_2_text = __("none");
		this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
		jQuery('.modal:not(.error)').modal();
    }

    handleBackClick() {
        if(jQuery('body').width() <= 1000) {
            console.log('clicked');
			if(jQuery('body').find('.feedback-detail-scroll').hasClass('is-hidden-mobile')) {
				jQuery('body').find('.feedback-list').addClass('is-hidden-mobile');
                jQuery('body').find('.dashboard-stats').addClass('is-hidden-mobile');
                jQuery('body').find('.feedback-detail-scroll').removeClass('is-hidden-mobile');
			} else if(jQuery('body').find('.feedback-list').hasClass('is-hidden-mobile')) {
				jQuery('body').find('.feedback-detail-scroll').addClass('is-hidden-mobile');
                jQuery('body').find('.feedback-list').removeClass('is-hidden-mobile');
                jQuery('body').find('.dashboard-stats').removeClass('is-hidden-mobile');
			}
		}
    }

    handleStatusClick(event){
		event.preventDefault();
		var status = jQuery(event.target).attr('id');
		var hide_chat_modal = false;
		var hide_notes_modal = false;
		var hide_review_modal = false;

		if(this.props.feedback.custom_qr_code){
			console.log("custom_qr_code");
			hide_chat_modal = this.props.feedback.custom_qr_code.hide_chat_modal;
			hide_notes_modal = this.props.feedback.custom_qr_code.hide_notes_modal;
			hide_review_modal = this.props.feedback.custom_qr_code.hide_review_modal;
		}
		if(status !== this.props.feedback.status){
			var id = this.props.feedback.feedback_id;
			if (status === window.feedbackStatus.Open.value) {
				this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
			} else if(status === window.feedbackStatus.Resolved.value) {
				if(this.props.feedback.chats.length === 0 && this.props.feedback.is_text === 1 && !hide_chat_modal) {
					var modal_id = "statusModal";
					var modal_title =__( "Update Status");
					var modal_body = __("You are marking a Feedback as 'Resolved' where a chat/text response has been requested but no chat has been initiated by an employee. If the issue has been resolved, please consider sending them a chat to let them know, or consider adding notes to the system detailing how the feedback was resolved.");
					var button_1_class = "primary";
					var button_1_id = "cancel";
					var button_1_text = __("Cancel - I'll send them a chat");
					var button_2_class = "outline-secondary";
					var button_2_id = "setResolved";
					var button_2_text = __("Continue without sending a chat");
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				} else if(this.props.feedback.chats.length === 0 && !this.props.feedback.is_text && this.props.feedback.notes.length === 0 && !hide_notes_modal) {
					var modal_id = "statusModal";
					var modal_title = __("Update Status");
					var modal_body = 'You are marking a Feedback as "Resolved" without any including any details about why it is being closed out. We encourage you to add notes to the Feedback detailing how it was resolved.';
					var button_1_class = "primary modal-add-notes-button";
					var button_1_id = "cancel";
					var button_1_text = __("Cancel - I'll add notes");
					var button_2_class = "outline-secondary";
					var button_2_id = "setResolved";
					var button_2_text = __("Continue without adding notes");
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				} else if ((this.props.feedback.business.rating_request) && reviewLinkSent(this.props.feedback.chats) === false && this.props.feedback.is_text === 1 && !hide_review_modal) {
					var modal_id = "statusModal";
					var modal_title = __("Update Status");
					var modal_body = __("You are marking a Feedback as 'Resolved' where a Review Request link has not yet been sent to the Feedbacker in chat. If the issue has been resolved, please consider sending them the Review Request link in chat. ");
					var button_1_class = "primary";
					var button_1_id = "cancel";
					var button_1_text = __("Cancel - I'll send them a review request link");
					var button_2_class = "outline-secondary";
					var button_2_id = "setResolved";
					var button_2_text = __("Continue without sending the link");
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				} else {
					this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
				}
			} else if(status === window.feedbackStatus.Pending.value) {
				var index = findWithAttr(this.props.feedback.pendingreminders, "hashed_user_id", this.props.state.current_user);
				if(index !== false) {
					this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
				} else {
					var modal_id = "pendingModal";
					var modal_title = __("Update Status");
					var modal_body = "pendingModal"
					var button_1_class = "outline-secondary";
					var button_1_id = "cancel";
					var button_1_text = __("Cancel");
					var button_2_class = "outline-secondary";
					var button_2_id = "setPending";
					var button_2_text = __("Continue without setting a reminder");
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				}
			}
		}
	}

    componentDidMount() {
        $('[data-toggle="tooltip"]').each(function() {
            jQuery(this).tooltip({html: true, placement: 'bottom',
                container: 'body',
                boundary: 'window'
            });
        });

        $('[data-toggle="tooltip"]').each(function() {
			var title = jQuery(this).attr('data-original-title');
			jQuery(this).attr('title', title);
		});

    }
    componentDidUpdate() {
        $('[data-toggle="tooltip"]').each(function() {
            jQuery(this).tooltip({html: true, placement: 'bottom',
                container: 'body',
                boundary: 'window'
            });
        });

        $('[data-toggle="tooltip"]').each(function() {
			var title = jQuery(this).attr('data-original-title');
			jQuery(this).attr('title', title);
		});
    }

    render() {
        var moment = require('moment-timezone');

        var response_via_text = getRequestedVia(this.props.feedback);

        const {chat_alert, chat_button_text} = getChatStatus(this.props.feedback);

        const stars = getStarsJSX(this.props.feedback.ratethisbizrating?this.props.feedback.ratethisbizrating.rating:null);

        const attachments = getAttachmentsUrls(this.props.feedback);

        var email_forward = genEmailButton(this.props.feedback, 'dropdown-item text-primary');

        var tags =
            this.props.state.business &&
            this.props.state.business.tags &&
            this.props.state.business.tags.length > 0;

        var archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-outline-danger d-inline-block archive-button text-capitalize"><i className="fas fa-archive mr-1"></i> { __('Archive') }</a>;
		if (this.props.feedback.is_archived) {
			archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-warning d-inline-block archive-button text-capitalize"><i className="fas fa-archive mr-1"></i> { __('Unarchive') }</a>;
        }

        var main_classes = "col-sm-12 col-md-12 col-lg-8 feedback-detail-scroll scroll mb-10 is-hidden-mobile";
        if(this.props.state.hide_initial_feedbacks) {
            main_classes = "col-sm-12 col-md-12 col-lg-8 feedback-detail-scroll scroll mb-10 ml-0";
        }

        return (
                <div className={main_classes} id={this.props.center?"center-detail":null}>
                    {!this.props.state.hide_initial_feedbacks &&
                    <button className="btn btn-sm btn-primary d-block d-lg-none mb-3" onClick={this.handleBackClick.bind(this)}><i className="fas fa-arrow-circle-left mr-1"></i> { __('Back') }</button>
                    }
                {/* <Alert alert={this.props.state.alert.alert} location={'status'}/> */}
                <div className="card feedback-detail">
                    <div className="title-row d-flex align-items-center">
                        {/* <div className="card-title"><span className="d-none d-sm-block mr-1">Feedback</span>Details</div>  */}
                        <div className="card-title">
                            <h5 className="pb-0 mb-0 text-default d-flex align-items-center">
								<span className="d-none d-sm-inline">
									{ __('Feedback Status') }
								</span>
                            { this.props.current_user &&
                                <div className="dropdown d-inline w-auto">
                                    <button className="btn btn-card dropdown-toggle text-primary pb-0 pt-0 font-weight-bold status-dropdown-button" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {window.feedbackStatus[this.props.feedback.status].label}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a className="dropdown-item" id={window.feedbackStatus.Open.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Open.label}</a>
                                        <a className="dropdown-item" id={window.feedbackStatus.Pending.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Pending.label}</a>
                                        <a className="dropdown-item" id={window.feedbackStatus.Resolved.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Resolved.label}</a>
                                        {this.props.state.businessHasAutoPilot && this.props.feedback.ratethisbizrating && !this.props.feedback.description ? (<a className="dropdown-item" id={window.feedbackStatus.RatingsOnly.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.RatingsOnly.label}</a>) : null}
                                    </div>
                                </div>
                            }
                            {!this.props.current_user &&
                                <span className="ml-2">{window.feedbackStatus[this.props.feedback.status].label}</span>
                            }
							{this.props.feedback.is_internal ? <b className="d-none d-sm-inline mr-2">{ __('Submitted Internally') }</b> : null}
                            </h5>
                        </div>
                        {this.props.feedback.status !== window.feedbackStatus.Resolved.value && this.props.feedback.pendingreminders && findWithAttr(this.props.feedback.pendingreminders, "hashed_user_id", this.props.current_user) !== false && !this.props.feedback.pendingreminders[findWithAttr(this.props.feedback.pendingreminders, "hashed_user_id", this.props.current_user)].sent_at &&
                        <h6 className='text-muted mb-0 reminder-text'>{"Reminder Set For: " + moment.utc(this.props.feedback.pendingreminders[findWithAttr(this.props.feedback.pendingreminders, "hashed_user_id", this.props.current_user)].remind_at, "YYYY-MM-DD HH:mm").clone().tz(moment.tz.guess()).format("M/D/YYYY, h:mm A z") }</h6>
                        }
                        {this.props.current_user &&
                            <div className="card-title ml-auto mr-0 pr-0">
                                {archive_button}
                            </div>
                        }
                        {this.props.current_user &&
                        <div className="card-title mr-0 pr-0 pl-0 ml-2">
                            <a href="#" className="btn btn-sm btn-default btn-outline-primary view-history"><i className="fas fa-history mr-1"></i>{ __('View Status History') }</a>
                        </div>
                        }
                        {this.props.current_user &&
                        <div className="card-title ml-2 pl-0">
                            <div className="dropdown">
                                <button className="btn btn-sm btn-default btn-outline-primary dropdown-toggle no-arrow" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="fas fa-share-square"></i> { __('Forward') }
                                </button>
                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                    <a className="dropdown-item text-primary" onClick={this.handleEmailClick} href="#"><i className="far fa-envelope mr-1"></i> { __('Via Email') }</a>
                                    <a className="dropdown-item text-primary" onClick={this.handleForwardClick} href="#"><i className="far fa-comment mr-1"></i> { __('Via Text Message') }</a>
                                    <a className="dropdown-item text-primary" onClick={this.handleHistoryClick} href="#"><i className="fas fa-history mr-1"></i> { __('Forward History') }</a>
                                </div>
			                </div>
                        </div>
                        }
						{window.is_impersonating == 1 &&
							<a href={"/feedback/"+ this.props.feedback.feedback_id +"/generate-review"} target="_blank" className="btn btn-sm btn-secondary mr-3"><i className="far fa-star"></i></a>
						}
                    </div>

                    {/* <StatusSection feedback={this.props.feedback} current_user={this.props.current_user} /> */}

                    <FeedbackSection feedback={this.props.feedback} current_user={this.props.current_user} dispatch={this.props.dispatch}/>

					<AttachmentSection attachments={attachments} feedback={this.props.feedback} current_user={this.props.current_user} />

                    <ChatSection feedback={this.props.feedback} current_user={this.props.current_user} dispatch={this.props.dispatch} />

                    <NoteSection feedback={this.props.feedback} user_id={this.props.current_user} ref={this._notesection} current_user={this.props.current_user}/>

                    {this.props.current_user &&
                    <ReviewSection feedback={this.props.feedback} current_user={this.props.current_user} />
                    }

                    {this.props.current_user && tags ? <TagsSection feedback={this.props.feedback} current_user={this.props.current_user} /> : null}

                    <AdminAttachmentSection feedback={this.props.feedback} current_user={this.props.current_user} />


                </div>
            </div>
            );
    }

}

function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        current_user: state.current_user,
        state: state
    }
}

export default connect(mapStateToProps)(FeedbackDetail)
